/*=========================================================================================
  File Name: module-notification-banner-actions.js
  Description: NotificationBanner Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import NotificationBannerAPI from '@/api/NotificationBannerAPI';

export default {
	/**
	 * Lấy thông báo hệ thống đang active từ API (backed bởi cache, gọi khi app mount hoặc tab focus lại)
	 */
	fetchActiveBanner: async function(context) {
		try {
			const res = await NotificationBannerAPI.getActive();
			if (res && res.Success) {
				if (res.Data) {
					//Lưu ý: entity/DTO backend dùng Content/ContentHtml, còn push payload SignalR dùng Message/MessageHtml (xem plan.md)
					//Fallback cả 2 tên field để tránh lệch response shape giữa REST và SignalR
					context.commit('updateBanner', {
						id: res.Data.Id,
						isActive: res.Data.IsActive,
						message: res.Data.Message || res.Data.Content,
						messageHtml: res.Data.MessageHtml || res.Data.ContentHtml
					});
				} else {
					context.commit('hideBanner');
				}
			}
		} catch (ex) {
			//Không throw để không chặn quá trình khởi tạo app
		}
	}
};
